import { render } from "./registration.vue?vue&type=template&id=1ae0f850&scoped=true"
import script from "./registration.vue?vue&type=script&lang=js"
export * from "./registration.vue?vue&type=script&lang=js"

import "./registration.vue?vue&type=style&index=0&id=1ae0f850&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae0f850"]])

export default __exports__